import { calculatePaginationOffset, compareValues, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const behaviorApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getBehavior: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/behavior`,
                params: {
                    description: data.filter.description,
                    category: data.filter.category,
                    prevalence: data.filter.prevalence.join(","),
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                    sort_by: convertSortToQueryString(data.sort),
                },
            }),
        }),
        getBehaviorSources: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/behavior/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
        getBehaviorDescriptions: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/behavior/descriptions`,
            }),
            transformResponse: (data) => {
                return data.sort((first, second) => compareValues(first.id, second.id, false));
            },
        }),
        getBehaviorCategories: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/behavior/categories`,
            }),
            transformResponse: (data) => {
                return {
                    categories: data.categories.sort((first, second) => compareValues(first, second, false)),
                };
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetBehaviorQuery, useGetBehaviorSourcesQuery, useLazyGetBehaviorDescriptionsQuery, useLazyGetBehaviorCategoriesQuery, } = behaviorApi;
//# sourceMappingURL=behavior.api.js.map